import React from 'react'
import { useTranslation } from 'react-i18next'
import { Target } from 'lucide-react'
import { Card, CardContent } from '../../../../components/ui/card'
import { cn } from '../../../../lib/utils'

const BARS = [
  { key: 'kcal', color: 'bg-app-primary-500' },
  { key: 'protein', color: 'bg-red-500' },
  { key: 'carbs', color: 'bg-blue-500' },
  { key: 'fat', color: 'bg-yellow-500' },
]

export function MacroAdherence({ adherence }) {
  const { t } = useTranslation()

  if (!adherence?.hasAnyTarget) {
    return (
      <Card>
        <CardContent className="p-4 text-center text-xs text-muted-foreground" dir="auto">
          {t('phoenixTracker.analysis.adherence.noTargets')}
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Target className="w-4 h-4 text-app-primary-500" />
          <h3 className="text-sm font-semibold text-foreground" dir="auto">
            {t('phoenixTracker.analysis.adherence.title')}
          </h3>
        </div>

        <p className="text-[11px] text-muted-foreground mb-3" dir="auto">
          {t('phoenixTracker.analysis.adherence.subtitle', {
            days: adherence.daysWithMeals,
            total: adherence.daysCounted,
          })}
        </p>

        <div className="space-y-2.5">
          {BARS.map(({ key, color }) => {
            const pct = adherence[key]
            if (pct == null) return null
            const pctVisual = Math.min(1, Math.max(0, pct))
            const pctText = Math.round(pct * 100)
            return (
              <div key={key}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-foreground" dir="auto">
                    {t(`phoenixTracker.analysis.adherence.${key}`)}
                  </span>
                  <span className="text-xs font-mono text-muted-foreground" dir="ltr">
                    {pctText}%
                  </span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
                  <div
                    className={cn('h-full rounded-full transition-[width]', color)}
                    style={{ width: `${pctVisual * 100}%` }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
